import { Dispatch, SetStateAction, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import messageBox from "../../assets/components/message/MessageBox";
import { baseUrl } from "../../config/serverConfig";
import useAxios from "../../hooks/axios/useAxios";
import { DefaultResponseType } from "../../types/axiosTypes";
import { Order } from "../../types/orderTypes";

const SendQuoteModal = ({
  order,
  refresh,
  setRefresh,
  resend = false,
}: {
  order: Order;
  refresh: boolean;
  setRefresh: Dispatch<SetStateAction<boolean>>;
  // true wanneer de offerte al eerder is gemaild: de knop wordt dan een
  // "opnieuw versturen"-actie (het endpoint staat herverzenden gewoon toe).
  resend?: boolean;
}) => {
  const [show, setShow] = useState(false);
  const [sending, setSending] = useState(false);

  const { fetchData } = useAxios({ method: "post" });

  const handleClose = () => {
    if (!sending) setShow(false);
  };

  const send = async () => {
    setSending(true);
    const response: DefaultResponseType<any> = await fetchData(
      `${baseUrl}/order/${order.id}/send-quote`,
      {}
    );
    setSending(false);

    if (response.error) {
      messageBox({
        message: "Offerte versturen mislukt. Probeer het opnieuw.",
        type: "error",
      });
    } else {
      messageBox({
        message: `Offerte verstuurd naar ${order.email}`,
        type: "success",
      });
      setShow(false);
      setRefresh(!refresh);
    }
  };

  return (
    <>
      <Button
        variant={resend ? "outline-success" : "success"}
        size="sm"
        onClick={() => setShow(true)}
      >
        {resend ? "Opnieuw versturen" : "Verstuur naar klant"}
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: 300, fontSize: "1.25rem" }}>
            Offerte versturen
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">
            Offerte versturen naar <strong>{order.email}</strong>?
          </p>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            De klant ontvangt een email met de PDF als bijlage.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleClose}
            disabled={sending}
          >
            Annuleren
          </Button>
          <Button variant="success" size="sm" onClick={send} disabled={sending}>
            {sending ? "Versturen..." : "Versturen"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SendQuoteModal;
